import { Injectable } from '@angular/core';

@Injectable()
export class PdfGlyphsService {

    glyphReplacements = [
        { 'key': 'ൻ്റ', 'value': '\u0d49' },
        { 'key': 'ക്ക', 'value': '\u0d01' },
        { 'key': 'ക്ത', 'value': '\u0d04' },
        { 'key': 'ക്ട', 'value': '\u0d0d' },
        { 'key': 'ക്സ', 'value': '\u0dbb' },
        { 'key': 'ക്ല', 'value': '\u0d11' },
        { 'key': 'ക്ഷ', 'value': '\u0d3b' },
        { 'key': 'ഗ്ഗ', 'value': '\u0d3c' },
        { 'key': 'ഗ്ദ', 'value': '\u0d4f' },
        { 'key': 'ഗ്മ', 'value': '\u0d50' },
        { 'key': 'ഗ്ന', 'value': '\u0d51' },
        { 'key': 'ഗ്ല', 'value': '\u0d52' },
        { 'key': 'ങ്ക', 'value': '\u0d53' },
        { 'key': 'ങ്ങ', 'value': '\u0d54' },
        { 'key': 'ച്ച', 'value': '\u0d55' },
        { 'key': 'ച്ഛ', 'value': '\u0d56' },
        { 'key': 'ജ്ജ', 'value': '\u0d58' },
        { 'key': 'ജ്ഞ', 'value': '\u0d59' },
        { 'key': 'ഞ്ച', 'value': '\u0d5a' },
        { 'key': 'ഞ്ജ', 'value': '\u0d5b' },
        { 'key': 'ഞ്ഞ', 'value': '\u0d5c' },
        { 'key': 'ട്ട', 'value': '\u0d5d' },
        { 'key': 'ഡ്ഡ', 'value': '\u0d5e' },
        { 'key': 'ഡ്ഢ', 'value': '\u0d5f' },
        { 'key': 'ണ്ഡ', 'value': '\u0d76' },
        { 'key': 'ണ്മ', 'value': '\u0d77' },
        { 'key': 'ണ്ണ', 'value': '\u0d78' },
        { 'key': 'ണ്ട', 'value': '\u0d80' },
        { 'key': 'ത്ന', 'value': '\u0d81' },
        { 'key': 'ത്ഭ', 'value': '\u0d82' },
        { 'key': 'ത്മ', 'value': '\u0d83' },
        { 'key': 'ത്സ', 'value': '\u0d84' },
        { 'key': 'ത്ത', 'value': '\u0d85' },
        { 'key': 'ത്ഥ', 'value': '\u0d86' },
        { 'key': 'ദ്ദ', 'value': '\u0d87' },
        { 'key': 'ദ്ധ', 'value': '\u0d88' },
        { 'key': 'ന്ദ', 'value': '\u0d89' },
        { 'key': 'ന്ധ', 'value': '\u0d8a' },
        { 'key': 'ന്ന', 'value': '\u0d8b' },
        { 'key': 'ന്മ', 'value': '\u0d8c' },
        { 'key': 'ന്ത', 'value': '\u0d8e' },
        { 'key': 'ന്ഥ', 'value': '\u0d8f' },
        { 'key': 'പ്പ', 'value': '\u0d90' },
        { 'key': 'പ്ല', 'value': '\u0d91' },
        { 'key': 'ഫ്ല', 'value': '\u0d92' },
        { 'key': 'ബ്ബ', 'value': '\u0d93' },
        { 'key': 'ബ്ദ', 'value': '\u0d94' },
        { 'key': 'ബ്ധ', 'value': '\u0d95' },
        { 'key': 'ബ്ല', 'value': '\u0d96' },
        { 'key': 'മ്മ', 'value': '\u0d97' },
        { 'key': 'മ്പ', 'value': '\u0d98' },
        { 'key': 'മ്ല', 'value': '\u0d99' },
        { 'key': 'യ്യ', 'value': '\u0d9a' },
        { 'key': 'റ്റ', 'value': '\u0d9b' },
        { 'key': 'ല്പ', 'value': '\u0d9c' },
        { 'key': 'ല്ല', 'value': '\u0d9d' },
        { 'key': 'ള്ള', 'value': '\u0d9e' },
        { 'key': 'വ്ള', 'value': '\u0d9f' },
        { 'key': 'വ്വ', 'value': '\u0da0' },
        { 'key': 'ശ്ച', 'value': '\u0da1' },
        { 'key': 'ശ്ശ', 'value': '\u0da2' },
        { 'key': 'ശ്ല', 'value': '\u0da3' },
        { 'key': 'ഷ്ട', 'value': '\u0da4' },
        { 'key': 'ഷ്ഠ', 'value': '\u0dba' },
        { 'key': 'സ്റ്റ', 'value': '\u0da5' },
        { 'key': 'സ്സ', 'value': '\u0da6' },
        { 'key': 'സ്ഥ', 'value': '\u0da7' },
        { 'key': 'സ്ല', 'value': '\u0da8' },
        { 'key': 'ഹ്മ', 'value': '\u0da9' },
        { 'key': 'ഹ്ന', 'value': '\u0daa' },
        { 'key': 'യ്ക', 'value': '\u0dac' },
        { 'key': 'യ്ക്ക', 'value': '\u0dad' },
        { 'key': 'സ്ത', 'value': '\u0dae' },
        { 'key': 'ഴ്ച', 'value': '\u0daf' },
        { 'key': 'സ്ന', 'value': '\u0db0' },
        { 'key': 'സ്പ', 'value': '\u0db1' },
        { 'key': 'ബ്ദ', 'value': '\u0db2' },
        { 'key': 'പ്സ', 'value': '\u0db3' },
        { 'key': 'സ്ക', 'value': '\u0db4' },
        { 'key': 'ഷ്പ', 'value': '\u0db5' },
        { 'key': 'സ്മ', 'value': '\u0db6' },
        { 'key': 'ഷ്മ', 'value': '\u0db7' },
        { 'key': 'ശ്മ', 'value': '\u0db8' },
        { 'key': 'ഹ്ള', 'value': '\u0db9' }
    ];

    constructor() { }


    glyphCorrection(str: string): string {
        let result = '';
        let choosed = '';
        let i: number;
        if (!!str) {
            this.glyphReplacements.forEach(function (item) {
                str = str.replace(item.key, item.value);
            });

            for (i = 0; i < str.length; i++) {
                choosed = str[i];
                if (choosed === 'െ' || choosed === 'േ' || choosed === 'ൈ') {
                    result = result.slice(-1) === '\u0d64' || result.slice(-1) === '\u0d45' ?
                        result.substring(0, result.length - 2) + choosed +
                        result.substring(result.length - 2, result.length - 1) + result.slice(-1) :
                        result.substring(0, result.length - 1) + choosed + result.slice(-1);
                } else if (choosed === 'ൊ') {
                    result = result.slice(-1) === '\u0d64' || result.slice(-1) === '\u0d45' ?
                        result.substring(0, result.length - 2) + 'െ' +
                        result.substring(result.length - 2, result.length - 1) + result.slice(-1) + 'ാ' :
                        result.substring(0, result.length - 1) + 'െ' + result.slice(-1) + 'ാ';
                } else if (choosed === 'ോ') {
                    result = result.slice(-1) === '\u0d64' || result.slice(-1) === '\u0d45' ?
                        result.substring(0, result.length - 2) + 'േ' +
                        result.substring(result.length - 2, result.length - 1) + result.slice(-1) + 'ാ' :
                        result.substring(0, result.length - 1) + 'േ' + result.slice(-1) + 'ാ';
                } else if (choosed === '്' && str[i + 1] === 'ര') {
                    result = result.substring(0, result.length - 1) + '\u0d65' + result.slice(-1);
                    i++;
                } else if (choosed === '്' && str[i + 1] === 'യ') {
                    result += '\u0d64';
                    i++;
                } else if (choosed === '്' && str[i + 1] === 'വ') {
                    result += '\u0d45';
                    i++;
                } else {
                    result += choosed;
                }
            }
        }
        return result;
    }

}
